export const REPORT_SUMMMERY_HEADERS = [
	{
		header: "Fuel No",
		accessorKey: "FuelNo",
		Cell: ({ row }) => row.index + 1,
	},
	{
		header: "Name of fuel",
		accessorKey: "NameOfFuel",
	},
	{
		header: "Emission Factor (MT CO2/MT fuel)",
		accessorKey: "EmissionFactor",
	},
	{
		header: "Fuel Consumption (MT)",
		accessorKey: "FuelConsumption",
	},
	{
		header: "Differentiating Criteria",
		accessorKey: "DifferentiatingCriteria",
	},
	{
		header: "CO2 Emitted (MT CO2)",
		accessorKey: "Co2Emitted",
	},
];

export const REPORT_SUMMMERY_HEADERS_FIRST_VERSION = [
	{
		header: "Fuel No",
		accessorKey: "FuelNo",
		id: "voyage_FuelNo",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "voyage_nameOfFuel",
		header: "Name of fuel",
		accessorKey: "nameOfFuel",
	},
	{
		id: "voyage_emissionFactor",
		header: "Emission Factor (MT CO2/MT fuel)",
		accessorKey: "emissionFactor",
	},
	{
		id: "voyage_fuelConsumption",
		header: "Fuel Consumption (MT)",
		accessorKey: "fuelConsumption",
	},
	{
		id: "voyage_differentiatingCriteria",
		header: "Differentiating Criteria",
		accessorKey: "differentiatingCriteria",
	},
	{
		id: "voyage_co2Emitted",
		header: "CO2 Emitted (MT CO2)",
		accessorKey: "co2Emitted",
	},
];

export const REPORT_SUMMMERY_HEADERS_SECOND_VERSION = [
	{
		id: "fuelNo",
		header: "Fuel No",
		accessorKey: "fuelNo",
		Cell: ({ row }) => row.index + 1,
	},
	{
		header: "ID Key",
		id: "fuelIdkey",
		accessorKey: "fuelIdkey",
	},
	{
		header: "Fuel Type",
		id: "fuelType",
		accessorKey: "fuelType",
	},
	{
		header: "LCV (MJ/g)",
		id: "lcv",
		accessorKey: "lcv",
	},
	{
		header: "EUMRV EF CO2 (gCO2/gfuel)",
		id: "efCo2Mrv",
		accessorKey: "efCo2Mrv",
	},
	{
		header: "EUMRV EF CH4 (gCH4/gfuel)",
		id: "efCh4Mrv",
		accessorKey: "efCh4Mrv",
	},
	{
		header: "EUMRV EF N2O (gN2O/gfuel)",
		id: "efN2oMrv",
		accessorKey: "efN2oMrv",
	},
	{
		header: "EUETS EF CO2 (gCO2/gfuel)",
		id: "efCo2Ets",
		accessorKey: "efCo2Ets",
	},
	{
		header: "EUETS EF CH4 (gCH4/gfuel)",
		id: "efCh4Ets",
		accessorKey: "efCh4Ets",
	},
	{
		header: "EUETS EF N2O (gN2O/gfuel)",
		id: "efN2oEts",
		accessorKey: "efN2oEts",
	},
	{
		header: "Activity",
		id: "activity",
		accessorKey: "activity",
	},
	{
		header: "Differentiating Criteria",
		id: "differentiatingCriteria",
		accessorKey: "differentiatingCriteria",
	},
	{
		header: "Fuel Consumption (MT)",
		id: "fuelConsumption",
		accessorKey: "fuelConsumption",
	},
	{
		header: "Mi,nc (MT)",
		id: "mnc",
		accessorKey: "mnc",
	},
	{
		header: "CO2 MRV (MT)",
		id: "co2Mrv",
		accessorKey: "co2Mrv",
	},
	{
		header: "CH4 MRV (MT)",
		id: "ch4Mrv",
		accessorKey: "ch4Mrv",
	},
	{
		header: "N2O MRV (MT)",
		id: "n2oMrv",
		accessorKey: "n2oMrv",
	},
	{
		header: "CO2eq MRV (MT)",
		id: "co2EqMrv",
		accessorKey: "co2EqMrv",
	},
	{
		header: "CO2 ETS (MT)",
		id: "co2Ets",
		accessorKey: "co2Ets",
	},
	{
		header: "CH4 ETS (MT)",
		id: "ch4Ets",
		accessorKey: "ch4Ets",
	},
	{
		header: "N2O ETS (MT)",
		id: "n2oEts",
		accessorKey: "n2oEts",
	},
	{
		header: "CO2eq ETS (MT)",
		id: "co2EqEts",
		accessorKey: "co2EqEts",
	},
];

export const FUELTYPE_REPORT_SUMMMERY_HEADERS_SECOND_VERSION = [
	{
		id: "fuelNo",
		header: "Fuel No",
		accessorKey: "fuelNo",
		Cell: ({ row }) => row.index + 1,
	},
	{
		header: "ID Key",
		id: "fuelIdkey",
		accessorKey: "fuelIdkey",
	},
	{
		header: "Fuel Type",
		id: "fuelType",
		accessorKey: "fuelType",
	},
	{
		header: "LCV (MJ/g)",
		id: "lcv",
		accessorKey: "lcv",
	},
	{
		header: "EUMRV EF CO2 (gCO2/gfuel)",
		id: "efCo2Mrv",
		accessorKey: "efCo2Mrv",
	},
	{
		header: "EUMRV EF CH4 (gCH4/gfuel)",
		id: "efCh4Mrv",
		accessorKey: "efCh4Mrv",
	},
	{
		header: "EUMRV EF N2O (gN2O/gfuel)",
		id: "efN2oMrv",
		accessorKey: "efN2oMrv",
	},
	{
		header: "EUETS EF CO2 (gCO2/gfuel)",
		id: "efCo2Ets",
		accessorKey: "efCo2Ets",
	},
	{
		header: "EUETS EF CH4 (gCH4/gfuel)",
		id: "efCh4Ets",
		accessorKey: "efCh4Ets",
	},
	{
		header: "EUETS EF N2O (gN2O/gfuel)",
		id: "efN2oEts",
		accessorKey: "efN2oEts",
	},
	{
		header: "Fuel Consumption (MT)",
		id: "fuelConsumption",
		accessorKey: "fuelConsumption",
	},
	{
		header: "Mi,nc (MT)",
		id: "mnc",
		accessorKey: "mnc",
	},
	{
		header: "CO2 MRV (MT)",
		id: "co2Mrv",
		accessorKey: "co2Mrv",
	},
	{
		header: "CH4 MRV (MT)",
		id: "ch4Mrv",
		accessorKey: "ch4Mrv",
	},
	{
		header: "N2O MRV (MT)",
		id: "n2oMrv",
		accessorKey: "n2oMrv",
	},
	{
		header: "CO2eq MRV (MT)",
		id: "co2EqMrv",
		accessorKey: "co2EqMrv",
	},
	{
		header: "CO2 ETS (MT)",
		id: "co2Ets",
		accessorKey: "co2Ets",
	},
	{
		header: "CH4 ETS (MT)",
		id: "ch4Ets",
		accessorKey: "ch4Ets",
	},
	{
		header: "N2O ETS (MT)",
		id: "n2oEts",
		accessorKey: "n2oEts",
	},
	{
		header: "CO2eq ETS (MT)",
		id: "co2EqEts",
		accessorKey: "co2EqEts",
	},
];

export const EUMRVEmissionsLabels_b1_to_b9 = {
	totalMt: "b.1) Total (MT)",
	totalAtSea: "b.2) Total at sea (MT)",
	totalOnLaden: "b.3) Voyage - On laden (MT)",
	voyagesBetweenPorts:
		"b.4) From voyages between ports under a MS jurisdiction (MT)",
	voyagesFromPorts:
		"b.5) From voyages which departed from ports under a MS jurisdiction (MT)",
	voyagesToPorts: "b.6) From voyages to ports under a MS jurisdiction (MT)",
	withinPortsAtBerth:
		"b.7) Occurred within ports under a MS jurisdiction at berth (MT)",
	withinPorts: "b.8) Occurred within ports under a MS jurisdiction (includes at berth and movements within the port) (MT)",
};

export const EUETS_EMISSION_D_LABELS = {
	voyagesBetweenPorts:
		"d.1) From voyages between ports under a MS jurisdiction (MT)",
	voyagesFromPorts:
		"d.2) From voyages which departed from ports under a MS jurisdiction (MT)",
	voyagesToPorts: "d.3) From voyages to ports under a MS jurisdiction (MT)",
	withinPorts: "d.4) Occurred within ports under a MS jurisdiction (MT)",
	smallIslands: "d.5) Assigned to small islands - ETS Article 12(3-d)",
	omr: "d.6) Assigned to outermost regions (OMR) - ETS Article 12(3-b)",
	transnational:
		"d.7) Assigned to transnational PSC / PSO - ETS Article 12(3-c)",
};

export const AGGRIGATION_F_LABELS = {
	pointF1: "f.1) Point 1.1",
	certifiedFuels:
		"f.2) Point 1.1 to 1.2 - Certified Biofuels and RFNBO zero-rated",
	geographicScope: "f.3) Point 1.1 to 1.3 - Geographic scope",
	ccuCcs: "f.4) Point 1.1 to 1.4 - CCS & CCU",
	ports: "f.5) Point 1.1 to 1.5 - OMR, PSC/O and Small Islands",
	iceClass: "f.6) Point 1.1 to 1.6 - Ice Class",
	phaseIn: "f.7) Point 1.1 to 1.7 - Phase-in",
};

export const ENERGY_EMISSION_K_LABELS = {
	emissionsPerDistance: "	Emissions per distance (kg/nm)",
	emissionsPerTransport_MT: "	Emissions per transport work (g CO2/MT*nm)",
	emissionsPerTransport_DWT: "	Emissions per transport work (g CO2/DWT*nm)",
	emissionsPerTransport_M3: "	Emissions per transport work (g CO2/M3*nm)",
	emissionsPerTransport: "	Emissions per transport work (g CO2/*nm)",
	emissionsPerTransport_PAX: "	Emissions per transport work (g CO2/PAX*nm)",
	emissionsPerDistanceOnLaden:
		"	Emissions per distance on laden voyages (kg/nm)",
	emissionsPerTransportOnLaden_MT:
		"	Emissions per transport work on laden voyages (g CO2/(MT*nm))",
	emissionsPerTransportOnLaden:
		"	Emissions per transport work on laden voyages (g CO2/(*nm))",
	emissionsPerTransportOnLaden_PAX:
		"	Emissions per transport work on laden voyages (g CO2/(PAX*nm))",
	emissionsPerTransportOnLaden_DWT:
		"	Emissions per transport work on laden voyages (g CO2/(DWT*nm))",
	emissionsPerTransportOnLaden_M3:
		"	Emissions per transport work on laden voyages (g CO2/(M3*nm))",
};

export const CCS_CCU_LABELS = {
	ccuBetweenPorts:
		"e.1) CCS and CCU from voyages between ports under a MS jurisdiction (MT)",
	ccufromPorts:
		"e.2) CCS and CCU from voyages which departed from ports under a MS jurisdiction (MT)",
	ccuToPorts:
		"e.3) CCS and CCU from voyages to ports under a MS jurisdiction (MT)",
	ccuWithinPorts:
		"e.4) CCS and CCU occurred within ports under a MS jurisdiction (MT)",
};

export const ENERGY_FUEL_CONS_C02MRV_LABELS = {
	fuelConsPerDistance_TOTAL: "Fuel consumptions per distance (kg/nm)",
	fuelConsPerTransport: "Fuel consumptions per transport (g/*nm)",
	fuelConsPerTransport_MT: "Fuel consumptions per transport (g/MT*nm)",
	fuelConsPerTransport_PAX: "Fuel consumptions per transport (g/PAX*nm)",
	fuelConsPerTransport_DWT: "Fuel consumptions per transport (g/DWT*nm)",
	fuelConsPerTransport_M3: "Fuel consumptions per transport (g/M3*nm)",
	fuelConsPerDistanceOnLaden_TOTAL:
		"Fuel consumptions distance onladen (kg/nm)",
	fuelConsPerTransportOnLaden:
		"Fuel consumptions per transport onladen (g/*nm)",
	fuelConsPerTransportOnLaden_MT:
		"Fuel consumptions per transport onladen (g/MT*nm)",
	fuelConsPerTransportOnLaden_PAX:
		"Fuel consumptions per transport onladen (g/PAX*nm)",
	fuelConsPerTransportOnLaden_DWT:
		"Fuel consumptions per transport onladen (g/DWT*nm)",
	fuelConsPerTransportOnLaden_M3:
		"Fuel consumptions per transport onladen (g/M3*nm)",
};
